import { LayoutList, Link2, FolderPlus } from 'lucide-react';
import { ADMIN_GUARD } from '../admin-guard';
import { CONTEXTS, lazyView, type FeatureManifest } from '@/app/registry';
import { adminPositionsRoutes } from './routes';
import { SKILL_LINK_TAB, SKILL_GROUP_LINK_TAB } from './positionPanels';

const navTab = {
  id: 'admin-nav',
  label: 'Navigation',
  icon: LayoutList,
  view: lazyView(() => import('../views/AdminNavView'), 'AdminNavView'),
};

export const adminPositionsManifest: FeatureManifest = {
  id: 'admin-positions',
  contexts: [
    CONTEXTS.ADMIN_POSITIONS,
    CONTEXTS.ADMIN_POSITION_FORM,
    CONTEXTS.ADMIN_POSITION_CREATE,
  ],

  routes: [{ routes: adminPositionsRoutes, errorFallbackLabel: 'Postes', guard: ADMIN_GUARD }],

  centerView: {
    [CONTEXTS.ADMIN_POSITIONS]: lazyView(
      () => import('../views/AdminPositionsListView'),
      'AdminPositionsListView',
    ),
    [CONTEXTS.ADMIN_POSITION_FORM]: lazyView(
      () => import('../views/AdminPositionFormView'),
      'AdminPositionFormView',
    ),
    [CONTEXTS.ADMIN_POSITION_CREATE]: lazyView(
      () => import('../views/AdminPositionFormView'),
      'AdminPositionFormView',
    ),
  },

  panels: {
    left: {
      tabs: {
        [CONTEXTS.ADMIN_POSITIONS]: [navTab],
        [CONTEXTS.ADMIN_POSITION_FORM]: [navTab],
        [CONTEXTS.ADMIN_POSITION_CREATE]: [navTab],
      },
    },
    // Right panel: on-demand "link" forms opened from the form editors.
    // - direct skill (skill + grid + weight): edit + create — reuses AdminSkillLinkView.
    // - skill group (group + weight): edit only (create body carries no groups).
    right: {
      tabs: {
        [CONTEXTS.ADMIN_POSITION_FORM]: [
          {
            id: SKILL_LINK_TAB,
            label: 'Lier une compétence',
            icon: Link2,
            view: lazyView(() => import('../views/AdminSkillLinkView'), 'AdminSkillLinkView'),
          },
          {
            id: SKILL_GROUP_LINK_TAB,
            label: 'Lier un groupe',
            icon: FolderPlus,
            view: lazyView(
              () => import('../views/AdminPositionSkillGroupLinkView'),
              'AdminPositionSkillGroupLinkView',
            ),
          },
        ],
        [CONTEXTS.ADMIN_POSITION_CREATE]: [
          {
            id: SKILL_LINK_TAB,
            label: 'Lier une compétence',
            icon: Link2,
            view: lazyView(() => import('../views/AdminSkillLinkView'), 'AdminSkillLinkView'),
          },
        ],
      },
    },
  },

  enabledWhen: {
    roles: ['admin'],
  },

  panelRequirements: {
    [CONTEXTS.ADMIN_POSITIONS]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
    [CONTEXTS.ADMIN_POSITION_FORM]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
    [CONTEXTS.ADMIN_POSITION_CREATE]: {
      left: { open: true, defaultActiveTab: 'admin-nav' },
      right: { open: false },
    },
  },
};
